
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as coming_45soonxxUjngNcCKMeta } from "/app/apps/dashboard/src/pages/[school]/bundle/[code]/product/[product-code]/coming-soon.vue?macro=true";
import { default as coming_45soonpn4QMEv4UqMeta } from "/app/apps/dashboard/src/pages/[school]/class/[class-id]/bundle/[code]/product/[product-code]/coming-soon.vue?macro=true";
import { default as downloads1oFZQ2gHs2Meta } from "/app/apps/dashboard/src/pages/desktop-installers/downloads.vue?macro=true";
import { default as indexabAJ1c47MWMeta } from "/app/apps/dashboard/src/pages/index.vue?macro=true";
import { default as acceptmRjwNRDkglMeta } from "/app/apps/dashboard/src/pages/invitation/[schoolId]/class_enrollment/[classId]/[invitationId]/accept.vue?macro=true";
import { default as ReviewProfiledIb3Xqj1QdMeta } from "/app/apps/dashboard/src/pages/invitation/[schoolId]/class_enrollment/[classId]/[invitationId]/ReviewProfile.vue?macro=true";
import { default as teacherInvitekRHwgOBVVpMeta } from "/app/apps/dashboard/src/pages/invitation/[schoolId]/class_enrollment/[classId]/[invitationId]/teacherInvite.vue?macro=true";
import { default as classFullAv7oufTjdEMeta } from "/app/apps/dashboard/src/pages/invitation/classFull.vue?macro=true";
import { default as inviteSuccessbXD7HBAAyEMeta } from "/app/apps/dashboard/src/pages/invitation/inviteSuccess.vue?macro=true";
import { default as mainmBKS98GnFLMeta } from "/app/apps/dashboard/src/pages/invitation/main.vue?macro=true";
import { default as successyDPebNerGgMeta } from "/app/apps/dashboard/src/pages/invitation/success.vue?macro=true";
import { default as _91scheduleType_93z66IIFTY7WMeta } from "/app/apps/dashboard/src/pages/learner/[school]/class/[class]/product/[component]/content-access/[rule]/[scheduleType].vue?macro=true";
import { default as _91_91class_93_93ds8q7TWhkHMeta } from "/app/apps/dashboard/src/pages/learner/[school]/externalresources/[code]/[[class]].vue?macro=true";
import { default as _91_91class_93_93EGQVOcH7T9Meta } from "/app/apps/dashboard/src/pages/learner/[school]/resourcebank/[code]/[[class]].vue?macro=true";
import { default as dashboardJvcXofJ9JWMeta } from "/app/apps/dashboard/src/pages/learner/dashboard.vue?macro=true";
import { default as addClass3m59tOpeWkMeta } from "/app/apps/dashboard/src/pages/learner/startlearning/addClass.vue?macro=true";
import { default as classwmApQpAGEnMeta } from "/app/apps/dashboard/src/pages/learner/startlearning/addMaterial/class.vue?macro=true";
import { default as indexcdpfQvpT8SMeta } from "/app/apps/dashboard/src/pages/learner/startlearning/addMaterial/index.vue?macro=true";
import { default as mainSFly9go5aJMeta } from "/app/apps/dashboard/src/pages/learner/startlearning/main.vue?macro=true";
import { default as my_45profileaywwiz4uAuMeta } from "/app/apps/dashboard/src/pages/my-profile.vue?macro=true";
import { default as _91userId_93b9GpNZWac3Meta } from "/app/apps/dashboard/src/pages/parent/activateMaterial/[userId].vue?macro=true";
import { default as createChildTZMdHXGcmPMeta } from "/app/apps/dashboard/src/pages/parent/createChild.vue?macro=true";
import { default as dashboardO70AB82RxGMeta } from "/app/apps/dashboard/src/pages/parent/dashboard.vue?macro=true";
import { default as _91userId_930QgWIr83iuMeta } from "/app/apps/dashboard/src/pages/parent/editChildProfile/[userId].vue?macro=true";
import { default as _91userId_937DAUA2kZ6wMeta } from "/app/apps/dashboard/src/pages/parent/join-class/[userId].vue?macro=true";
import { default as _91userId_93XDI974887fMeta } from "/app/apps/dashboard/src/pages/parent/resetChildPassword/[userId].vue?macro=true";
import { default as _91userId_93PHLTnxXai3Meta } from "/app/apps/dashboard/src/pages/parent/viewChildDetails/[userId].vue?macro=true";
import { default as return_45urlHxtr5pyvClMeta } from "/app/apps/dashboard/src/pages/return-url.vue?macro=true";
import { default as _91app_93mpVMcCAgKUMeta } from "/app/apps/dashboard/src/pages/teacher/[school]/activateMaterial/[learnerId]/[app].vue?macro=true";
import { default as _91component_45code_93CI6LvLGON5Meta } from "/app/apps/dashboard/src/pages/teacher/[school]/bundle/[code]/class/[class-id]/digital-component/[component-code].vue?macro=true";
import { default as _91component_45code_93MPQ2nZcHl5Meta } from "/app/apps/dashboard/src/pages/teacher/[school]/bundle/[code]/digital-component/[component-code].vue?macro=true";
import { default as viewaDDD1LmYM7Meta } from "/app/apps/dashboard/src/pages/teacher/[school]/bundle/[code]/view.vue?macro=true";
import { default as _91_91class_93_93V6naS7HNa6Meta } from "/app/apps/dashboard/src/pages/teacher/[school]/externalresources/[code]/[[class]].vue?macro=true";
import { default as _91_91class_93_93r3pfZYAJ71Meta } from "/app/apps/dashboard/src/pages/teacher/[school]/resourcebank/[code]/[[class]].vue?macro=true";
import { default as indexmTddthQOYKMeta } from "/app/apps/dashboard/src/pages/teacher/account-setup/index.vue?macro=true";
import { default as joinSchoolOptions0R8xFYAGW1Meta } from "/app/apps/dashboard/src/pages/teacher/account-setup/step/joinSchoolOptions.vue?macro=true";
import { default as create_45class38yMVh6pLTMeta } from "/app/apps/dashboard/src/pages/teacher/create-class.vue?macro=true";
import { default as dashboardB1Qbn0H68EMeta } from "/app/apps/dashboard/src/pages/teacher/dashboard.vue?macro=true";
import { default as _91umbrellaCode_93FBch8udIkqMeta } from "/app/apps/dashboard/src/pages/teacher/freetrial/questionnaire/[umbrellaCode].vue?macro=true";
import { default as librarygZoO8sh2MFMeta } from "/app/apps/dashboard/src/pages/teacher/library.vue?macro=true";
import { default as setupschoolBW9AzPo0TAMeta } from "/app/apps/dashboard/src/pages/teacher/setupschool.vue?macro=true";
import { default as independentteacherngFgHzPfgvMeta } from "/app/apps/dashboard/src/pages/teacher/startteaching/independentteacher.vue?macro=true";
import { default as joinSchooly9TXO2FkpvMeta } from "/app/apps/dashboard/src/pages/teacher/startteaching/joinSchool.vue?macro=true";
import { default as trainingtHx6V54IFaMeta } from "/app/apps/dashboard/src/pages/teacher/training.vue?macro=true";
export default [
  {
    name: "school-bundle-code-product-productcode-coming-soon",
    path: "/:school()/bundle/:code()/product/:productcode()/coming-soon",
    meta: coming_45soonxxUjngNcCKMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/[school]/bundle/[code]/product/[product-code]/coming-soon.vue")
  },
  {
    name: "school-class-classid-bundle-code-product-productcode-coming-soon",
    path: "/:school()/class/:classid()/bundle/:code()/product/:productcode()/coming-soon",
    meta: coming_45soonpn4QMEv4UqMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/[school]/class/[class-id]/bundle/[code]/product/[product-code]/coming-soon.vue")
  },
  {
    name: "desktop-installers-downloads",
    path: "/desktop-installers/downloads",
    meta: downloads1oFZQ2gHs2Meta || {},
    component: () => import("/app/apps/dashboard/src/pages/desktop-installers/downloads.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/apps/dashboard/src/pages/index.vue")
  },
  {
    name: "invitation-schoolId-class_enrollment-classId-invitationId-accept",
    path: "/invitation/:schoolId()/class_enrollment/:classId()/:invitationId()/accept",
    meta: acceptmRjwNRDkglMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/invitation/[schoolId]/class_enrollment/[classId]/[invitationId]/accept.vue")
  },
  {
    name: "invitation-schoolId-class_enrollment-classId-invitationId-ReviewProfile",
    path: "/invitation/:schoolId()/class_enrollment/:classId()/:invitationId()/ReviewProfile",
    meta: ReviewProfiledIb3Xqj1QdMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/invitation/[schoolId]/class_enrollment/[classId]/[invitationId]/ReviewProfile.vue")
  },
  {
    name: "invitation-schoolId-class_enrollment-classId-invitationId-teacherInvite",
    path: "/invitation/:schoolId()/class_enrollment/:classId()/:invitationId()/teacherInvite",
    meta: teacherInvitekRHwgOBVVpMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/invitation/[schoolId]/class_enrollment/[classId]/[invitationId]/teacherInvite.vue")
  },
  {
    name: "invitation-classFull",
    path: "/invitation/classFull",
    meta: classFullAv7oufTjdEMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/invitation/classFull.vue")
  },
  {
    name: "invitation-inviteSuccess",
    path: "/invitation/inviteSuccess",
    meta: inviteSuccessbXD7HBAAyEMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/invitation/inviteSuccess.vue")
  },
  {
    name: "invitation-main",
    path: "/invitation/main",
    meta: mainmBKS98GnFLMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/invitation/main.vue")
  },
  {
    name: "invitation-success",
    path: "/invitation/success",
    meta: successyDPebNerGgMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/invitation/success.vue")
  },
  {
    name: "learner-school-class-class-product-component-content-access-rule-scheduleType",
    path: "/learner/:school()/class/:class()/product/:component()/content-access/:rule()/:scheduleType()",
    meta: _91scheduleType_93z66IIFTY7WMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/learner/[school]/class/[class]/product/[component]/content-access/[rule]/[scheduleType].vue")
  },
  {
    name: "learner-school-externalresources-code-class",
    path: "/learner/:school()/externalresources/:code()/:class?",
    meta: _91_91class_93_93ds8q7TWhkHMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/learner/[school]/externalresources/[code]/[[class]].vue")
  },
  {
    name: "learner-school-resourcebank-code-class",
    path: "/learner/:school()/resourcebank/:code()/:class?",
    meta: _91_91class_93_93EGQVOcH7T9Meta || {},
    component: () => import("/app/apps/dashboard/src/pages/learner/[school]/resourcebank/[code]/[[class]].vue")
  },
  {
    name: "learner-dashboard",
    path: "/learner/dashboard",
    meta: dashboardJvcXofJ9JWMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/learner/dashboard.vue")
  },
  {
    name: "learner-startlearning-addClass",
    path: "/learner/startlearning/addClass",
    meta: addClass3m59tOpeWkMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/learner/startlearning/addClass.vue")
  },
  {
    name: "learner-startlearning-addMaterial-class",
    path: "/learner/startlearning/addMaterial/class",
    meta: classwmApQpAGEnMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/learner/startlearning/addMaterial/class.vue")
  },
  {
    name: "learner-startlearning-addMaterial",
    path: "/learner/startlearning/addMaterial",
    meta: indexcdpfQvpT8SMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/learner/startlearning/addMaterial/index.vue")
  },
  {
    name: "learner-startlearning-main",
    path: "/learner/startlearning/main",
    meta: mainSFly9go5aJMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/learner/startlearning/main.vue")
  },
  {
    name: "my-profile",
    path: "/my-profile",
    meta: my_45profileaywwiz4uAuMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/my-profile.vue")
  },
  {
    name: "parent-activateMaterial-userId",
    path: "/parent/activateMaterial/:userId()",
    meta: _91userId_93b9GpNZWac3Meta || {},
    component: () => import("/app/apps/dashboard/src/pages/parent/activateMaterial/[userId].vue")
  },
  {
    name: "parent-createChild",
    path: "/parent/createChild",
    meta: createChildTZMdHXGcmPMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/parent/createChild.vue")
  },
  {
    name: "parent-dashboard",
    path: "/parent/dashboard",
    meta: dashboardO70AB82RxGMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/parent/dashboard.vue")
  },
  {
    name: "parent-editChildProfile-userId",
    path: "/parent/editChildProfile/:userId()",
    meta: _91userId_930QgWIr83iuMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/parent/editChildProfile/[userId].vue")
  },
  {
    name: "parent-join-class-userId",
    path: "/parent/join-class/:userId()",
    meta: _91userId_937DAUA2kZ6wMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/parent/join-class/[userId].vue")
  },
  {
    name: "parent-resetChildPassword-userId",
    path: "/parent/resetChildPassword/:userId()",
    meta: _91userId_93XDI974887fMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/parent/resetChildPassword/[userId].vue")
  },
  {
    name: "parent-viewChildDetails-userId",
    path: "/parent/viewChildDetails/:userId()",
    meta: _91userId_93PHLTnxXai3Meta || {},
    component: () => import("/app/apps/dashboard/src/pages/parent/viewChildDetails/[userId].vue")
  },
  {
    name: "return-url",
    path: "/return-url",
    component: () => import("/app/apps/dashboard/src/pages/return-url.vue")
  },
  {
    name: "teacher-school-activateMaterial-learnerId-app",
    path: "/teacher/:school()/activateMaterial/:learnerId()/:app()",
    meta: _91app_93mpVMcCAgKUMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/[school]/activateMaterial/[learnerId]/[app].vue")
  },
  {
    name: "teacher-school-bundle-code-class-classid-digital-component-componentcode",
    path: "/teacher/:school()/bundle/:code()/class/:classid()/digital-component/:componentcode()",
    meta: _91component_45code_93CI6LvLGON5Meta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/[school]/bundle/[code]/class/[class-id]/digital-component/[component-code].vue")
  },
  {
    name: "teacher-school-bundle-code-digital-component-componentcode",
    path: "/teacher/:school()/bundle/:code()/digital-component/:componentcode()",
    meta: _91component_45code_93MPQ2nZcHl5Meta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/[school]/bundle/[code]/digital-component/[component-code].vue")
  },
  {
    name: "teacher-school-bundle-code-view",
    path: "/teacher/:school()/bundle/:code()/view",
    meta: viewaDDD1LmYM7Meta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/[school]/bundle/[code]/view.vue")
  },
  {
    name: "teacher-school-externalresources-code-class",
    path: "/teacher/:school()/externalresources/:code()/:class?",
    meta: _91_91class_93_93V6naS7HNa6Meta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/[school]/externalresources/[code]/[[class]].vue")
  },
  {
    name: "teacher-school-resourcebank-code-class",
    path: "/teacher/:school()/resourcebank/:code()/:class?",
    meta: _91_91class_93_93r3pfZYAJ71Meta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/[school]/resourcebank/[code]/[[class]].vue")
  },
  {
    name: "teacher-account-setup",
    path: "/teacher/account-setup",
    meta: indexmTddthQOYKMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/account-setup/index.vue")
  },
  {
    name: "teacher-account-setup-step-joinSchoolOptions",
    path: "/teacher/account-setup/step/joinSchoolOptions",
    meta: joinSchoolOptions0R8xFYAGW1Meta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/account-setup/step/joinSchoolOptions.vue")
  },
  {
    name: "teacher-create-class",
    path: "/teacher/create-class",
    meta: create_45class38yMVh6pLTMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/create-class.vue")
  },
  {
    name: "teacher-dashboard",
    path: "/teacher/dashboard",
    meta: dashboardB1Qbn0H68EMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/dashboard.vue")
  },
  {
    name: "teacher-freetrial-questionnaire-umbrellaCode",
    path: "/teacher/freetrial/questionnaire/:umbrellaCode()",
    meta: _91umbrellaCode_93FBch8udIkqMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/freetrial/questionnaire/[umbrellaCode].vue")
  },
  {
    name: "teacher-library",
    path: "/teacher/library",
    meta: librarygZoO8sh2MFMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/library.vue")
  },
  {
    name: "teacher-setupschool",
    path: "/teacher/setupschool",
    meta: setupschoolBW9AzPo0TAMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/setupschool.vue")
  },
  {
    name: "teacher-startteaching-independentteacher",
    path: "/teacher/startteaching/independentteacher",
    meta: independentteacherngFgHzPfgvMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/startteaching/independentteacher.vue")
  },
  {
    name: "teacher-startteaching-joinSchool",
    path: "/teacher/startteaching/joinSchool",
    meta: joinSchooly9TXO2FkpvMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/startteaching/joinSchool.vue")
  },
  {
    name: "teacher-training",
    path: "/teacher/training",
    meta: trainingtHx6V54IFaMeta || {},
    component: () => import("/app/apps/dashboard/src/pages/teacher/training.vue")
  }
]